import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '@/components/Ad/BankPromo/BankPromo.styles';
import { useAdDetails } from '@/hooks/useAdDetails';
import {
  cardLink,
  creditLink,
} from '@/components/Ad/BankPromo/BankPromo.constants';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { useServerDataContext } from '@/contexts';

export const BankPromo = () => {
  const { t, i18n } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;

  if (!adData) {
    return (
      <S.BankPromoBox>
        <SkeletonLoader
          dataTestId="bank-promo-skeleton-loader"
          borderRadius={14}
          height="50px"
        />
      </S.BankPromoBox>
    );
  }

  const isBirkartBanner = adData.birkartBanner.hasCard;
  const isBirkartKreditBanner = adData.birkartBanner.hasKredit;

  function goToBank() {
    const link = isBirkartBanner ? cardLink : creditLink;
    window.open(link, '_blank');
  }

  if (!isBirkartBanner && !isBirkartKreditBanner) {
    return null;
  }

  return (
    <S.BankPromoBox>
      <S.BankPromoButton
        isFullWidth
        $isBirkartBanner={isBirkartBanner}
        $currentLanguage={i18n.language}
        onClick={goToBank}
        aria-label="Bank promo"
        data-testid="bank-promo-button"
        data-stat={isBirkartBanner ? 'birkart-btn' : 'kredit-btn'}
      >
        {!isBirkartBanner && t('pages.ad.get_credit')}
      </S.BankPromoButton>
    </S.BankPromoBox>
  );
};
